
define('text!gameInterfaces/pages/NetEntGameInterface.html',[],function () { return '<div></div>\n';});

